module.exports = __webpack_public_path__ + "img/downloads.ed0b3970.png";